import React, { useState } from "react";

import { AppDetail } from "./AppDetail";
import { AppsGrid } from "./AppsGrid";

/* Grid or one app, the way the rest of the app navigates: a state machine, not
   a route (`frontend/README.md`, deviation 4). `key` on the detail
   remounts it per slug so tab and expansion state never survive a different
   app. */
export default function AppsPage() {
  const [slug, setSlug] = useState<string | null>(null);

  return (
    <main className="flex-1 min-w-0 flex flex-col bg-[var(--canvas)]">
      {slug ? (
        <AppDetail key={slug} slug={slug} onBack={() => setSlug(null)} />
      ) : (
        <AppsGrid onOpen={setSlug} />
      )}
    </main>
  );
}
